// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"2b20de20","377":"9e469038","600":"670bb102"}[chunkId] + ".chunk.js";
};